import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Loader, NoResult, TitleWithArrowLink } from "../../../../components";
import { EndPoints } from "../../../../Constants/endpoints";
import { useGetData } from "../../../../hooks";
import { GetPatientInfo } from "../../../../interface/GeneralResponse";
import { formatDatePicker } from "../../../../utils/utils";

function ChronicDiseases({ className }: { className?: string }) {
  const { id } = useParams();

  const { t } = useTranslation();
  const { data, isPending } = useGetData<GetPatientInfo>(
    EndPoints.GetPatients,
    {},
    id,
  );
  const PatientsData = data?.Data;

  return (
    <div
      className={`h-full overflow-auto ps-4 ${className ? className : "max-h-[58vh]"}`}
    >
      {className ? (
        <TitleWithArrowLink title="chronic_diseases" />
      ) : (
        <h1 className="mb-2 text-sm font-bold">{t("chronic_diseases")}</h1>
      )}
      {isPending ? (
        <Loader />
      ) : (
        PatientsData?.ChronicDiseases.map((e, i) => (
          <div
            className={`text-primary-textFont flex rounded-lg p-2 text-sm ${i % 2 !== 0 ? "" : "bg-Gray"}`}
            key={i}
          >
            <h2 className="w-3/4">{e.Name}</h2>
            <p className="w-1/4">{formatDatePicker(e.SinceDate)}</p>
          </div>
        ))
      )}
      {!isPending && PatientsData?.ChronicDiseases?.length === 0 && (
        <NoResult />
      )}
    </div>
  );
}

export default ChronicDiseases;
